export default __webpack_public_path__ + "static/media/IMG HEADER@2x.3f2bbfa9.png";